export enum TimeReportStatus {
  Reported = 'reported',
  Locked = 'locked',
  Exported = 'exported',
  NotReported = 'notReported',
  LockedAndHasBeenEditedByAdmin = 'lockedAndHasBeenEditedByAdmin',
  NeedsReviewal = 'needsReviewal',
  HasBeenEditedByAdmin = 'hasBeenEditedByAdmin',
}
